module.exports = __webpack_public_path__ + "media/product/latest-deal-1-bd113a12.png";